export interface SocialLink {
  name: string;
  href: string;
}

// Single source of truth for PawPayments social profiles.
// Consumed by the landing Footer (visible icons) and JsonLd (`sameAs`).
export const SOCIAL_LINKS: SocialLink[] = [
  { name: "X", href: "https://x.com/paw_payments" },
  { name: "Telegram", href: "https://t.me/pawpayments" },
];
